import * as dailyQuota from './dailyQuota';
import * as priorizationDates from './priorizationDates';

import * as ActionTypes from './actionTypes';

const Actions = {
  ...dailyQuota,
  ...priorizationDates,
};

export {Actions, ActionTypes};
